import React, { Component } from 'react';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { Modal, Button } from 'react-bootstrap';
// `qrcode.react@^1.0.1` is React-16 compatible. Install once before deploying:
//   yarn add qrcode.react@^1.0.1
import QRCode from 'qrcode.react';
import { Config } from '../Config';
import { createSmartLink, reportClickEvent } from '../libs/appLink';
import tr from '../libs/tr';
import btnapplestore from '../images/public/userarea/btnapplestore.png';
import btngoogleplay from '../images/public/userarea/btngoogleplay.png';

export default class DownloadAppButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smartLink: null,
      clickId: null,
      fallbackUsed: false,
      modalOpen: false,
    };
  }

  componentDidMount() {
    const params = {
      source_page: this.props.source_page || 'unknown',
      utm_source: this.props.utm_source || 'webappsci',
      utm_medium: this.props.utm_medium || (isMobile ? 'mobile_web' : 'desktop_web'),
      utm_campaign: this.props.utm_campaign || null,
      utm_term: this.props.utm_term || null,
      utm_content: this.props.utm_content || null,
      partner_id: this.props.partner_id || null,
      referral_code: this.props.referral_code || null,
      target_path: this.props.target_path || null,
    };
    createSmartLink(params).then((res) => {
      if (!this._unmounted) {
        this.setState({
          smartLink: res.smart_link,
          clickId: res.click_id,
          fallbackUsed: res.fallback_used,
        });
      }
    });
  }

  componentWillUnmount() {
    this._unmounted = true;
  }

  onStoreClick = (platform) => {
    reportClickEvent('app_download_click', {
      source_page: this.props.source_page,
      platform,
      click_id: this.state.clickId,
      fallback_used: this.state.fallbackUsed,
    });
  };

  onDesktopClick = (e) => {
    if (e) e.preventDefault();
    reportClickEvent('app_download_qr_open', {
      source_page: this.props.source_page,
      click_id: this.state.clickId,
      fallback_used: this.state.fallbackUsed,
    });
    this.setState({ modalOpen: true });
  };

  closeModal = () => this.setState({ modalOpen: false });

  renderStoreBadges(href) {
    return (
      <React.Fragment>
        <div className="mb-3">
          <a
            className="goButton"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => this.onStoreClick('ios')}
          >
            <img src={btnapplestore} alt="App Store" />
          </a>
        </div>
        <div className="mb-3">
          <a
            className="goButton"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => this.onStoreClick('android')}
          >
            <img src={btngoogleplay} alt="Google Play" />
          </a>
        </div>
      </React.Fragment>
    );
  }

  render() {
    // Prefer the tracked smart link returned by the backend. If the click
    // endpoint failed we still send the user to the right store directly so
    // the CTA never dead-ends — we just lose attribution for that click.
    const platformFallback = isIOS
      ? Config.iosAppStoreUrl
      : isAndroid
        ? Config.androidPlayStoreUrl
        : Config.iosAppStoreUrl;
    const href = this.state.smartLink || platformFallback;

    if (isIOS) {
      return (
        <div className="mb-3">
          <a
            className="goButton"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => this.onStoreClick('ios')}
          >
            <img src={btnapplestore} alt="App Store" />
          </a>
        </div>
      );
    }

    if (isAndroid) {
      return (
        <div className="mb-3">
          <a
            className="goButton"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => this.onStoreClick('android')}
          >
            <img src={btngoogleplay} alt="Google Play" />
          </a>
        </div>
      );
    }

    // Desktop: QR modal + click-through fallback
    return (
      <React.Fragment>
        <div className="mb-3 d-flex flex-column align-items-center">
          <Button variant="primary" onClick={this.onDesktopClick}>
            {tr.t('Downloadapp') || 'Download the app'}
          </Button>
        </div>
        <Modal show={this.state.modalOpen} onHide={this.closeModal} centered>
          <Modal.Body className="text-center p-4">
            <h5 className="mb-3">{tr.t('Downloadnow') || 'Scan with your phone'}</h5>
            <div className="d-flex justify-content-center mb-3">
              <QRCode value={href} size={200} level="M" includeMargin />
            </div>
            <p className="text-muted small mb-3">{href}</p>
            {this.renderStoreBadges(href)}
            <Button variant="link" onClick={this.closeModal}>
              {tr.t('Close') || 'Close'}
            </Button>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DownloadAppButton.js